import React, { useEffect, useState } from 'react';
import { DatePicker, Form, Checkbox } from 'antd';
import { DatePickerProps } from 'antd/lib/date-picker';
import moment from 'moment';

// 定义自定义 DatePicker 组件的属性类型
interface CustomDatePickerProps extends Omit<DatePickerProps, 'value' | 'onChange'> {
  value?: string;
  onChange?: (dateString: string) => void;
  allowPermanent?: boolean;
  disabled?: boolean;
}

// 自定义 DatePicker 组件
const SPDatePickerString: React.FC<CustomDatePickerProps> = ({ value, onChange, allowPermanent = false,disabled, ...rest }) => {
  const [isPermanent, setIsPermanent] = useState<boolean>(false);

  const handleChange = (date: moment.Moment | null, dateString: string) => {
    if (onChange) {
      onChange(dateString);
    }
  };

  const handleCheckboxChange: any = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setIsPermanent(checked);
    if (checked && onChange) {
      onChange('2090-01-01 23:59:59');
    } else if (!checked && onChange) {
      onChange(''); // 清空日期
    }
  };

  useEffect(() => {
    if (value == '2090-01-01 23:59:59') {
      setIsPermanent(true);
    } else {
      setIsPermanent(false);
    }
  }, [value]);

  return (
    <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <DatePicker
        style={{ flex: 1 }}
        value={isPermanent ? moment('2090-01-01 23:59:59') : value ? moment(value) : null}
        onChange={handleChange}
        disabled={isPermanent || disabled}
        {...rest}
      />
      {allowPermanent && (
        <Checkbox disabled={disabled} style={{marginLeft: '20px'}} checked={isPermanent} onChange={handleCheckboxChange}>
          永久有效
        </Checkbox>
      )}
    </div>
  );
};

export default SPDatePickerString
